import React from 'react';
import { alertError } from '../config/toast';
import { getPaymentsReq } from '../config/httpRoutes';
import { Col, Form, Row, Button } from 'react-bootstrap';
import Loader from '../components/loader';
import { getFormattedDate } from '../config/helpers';
import { commaRE } from '../config/regex';
import DateInput from '../components/dateInput';
import { CSVLink } from "react-csv";
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const headers = [
	{label: 'ID', key: 'id'},
	{label: 'Seller Name', key: 'seller.name'},
	{label: 'Seller ID', key: 'seller.id'},
	{label: 'Date', key: 'date'},
	{label: 'Earning', key: 'earnings'},
	{label: 'Cutoff', key: 'cutoff'},
	{label: 'Paid Amount', key: 'paid'},
	{label: 'Paid On', key: 'paid_date'},
];

class Payments extends React.Component {
	constructor(props) {
		super(props);
		
		this.now = Date.now();
		this.state = {
			payments: null,
			dt: new Date(),

			fetchLoading: true
		};
	}

	componentDidMount() {
		this.getPayments();
	}

	getPayments = (e) => {
		e && e.preventDefault();
		const { dt } = this.state;
		this.setState({fetchLoading: true});
		getPaymentsReq({ts: dt && dt.getTime ? dt.getTime() : this.now})
		.then( (res) => {
			this.setState({payments: res.data.map( (p) => ({
				...p,
				date: getFormattedDate(parseInt(p.date)),
				earning: `₹ ${p.earnings?.toString().replace(commaRE, ',') || ''}`,
				paid: `₹ ${p.paid?.toString().replace(commaRE, ',') || ''}`,
				paid_date: getFormattedDate(parseInt(p.paid_date)),
				// sellerid: p.seller.id,
				// sellername: p.seller.name,
			}))});
		}).catch( (err) => {
			alertError(err.response?.data?.msg || "Could not fetch payments");
		}).finally( () => {
			this.setState({fetchLoading: false});
		});
	}

	onChangeDate = (name, e) => {
		this.setState({ [name]: e || new Date() });
	}

	render() {
		const { payments, fetchLoading, dt } = this.state;
		const { getPayments, onChangeDate } = this;
		return (
			<Row style={{marginLeft: 0, marginRight: 0, paddingLeft: '10%', paddingRight: '10%', paddingTop: '5%', minHeight: '60vh'}}>
				{fetchLoading && <Loader />}
				<Col md={12} style={{justifyContent: 'space-between', display: 'flex', marginTop: '10px', marginBottom: '15px', height: 60}}>
					<Form onSubmit={getPayments} style={{justifyContent: 'space-between', display: 'flex'}}>
						<Form.Group>
							<DateInput name="dt" selected={dt} onChange={(e) => { onChangeDate('dt', e) }} placeholderText="Date" />
						</Form.Group>
						<Button type="submit" variant="success" size="sm" style={{height: 40, marginLeft: 20, alignSelf: 'center'}}>
							Get Payments
						</Button>
					</Form>
					{Array.isArray(payments) && payments.length > 0 ?
						<CSVLink className="btn btn-success mr-1" data={payments} headers={headers} style={{height: 40, marginLeft: 20, alignSelf: 'center'}}>
							<FontAwesomeIcon icon={faDownload} /> Export CSV
						</CSVLink>
					:
						<></>
					}
				</Col>
				{Array.isArray(payments) ?
					payments.length > 0 ?
						<div className="table-responsive">
							<table className="table table-hover table-attendance">
								<thead>
									<tr>
										<th>ID</th>
										<th>Seller Name/ID</th>
										<th>Date</th>
										<th>Earning</th>
										<th>Cutoff</th>
										<th>Paid Amount</th>
										<th>Paid on</th>
									</tr>
								</thead>
								<tbody>
									{payments.map(({ id, seller, earnings, paid, cutoff, date, paid_date }, i) =>
										<tr key={i}>
											<td>{id}</td>
											<td>{seller?.name}/{seller?.id}</td>
											<td>{date}</td>
											<td>{earnings}</td>
											<td>{cutoff} %</td>
											<td>{paid}</td>
											<td>{paid_date}</td>
										</tr>
									)}
								</tbody>
							</table>
						</div>
					:
						<p style={{position: 'fixed', marginLeft: '34%', marginTop: '20%'}}>No payments found.</p>
				:
					<></>
				}
			</Row>
		);
	}
}

export default Payments;